import { appointmentValidate } from "../../application/dtos/appointment_validate";

export class AppointmentEntity {
    constructor({ 
        id, 
        eta, 
        arrival_date, 
        modulation_date, 
        modulation_time, 
        origin_supplier, 
        standby_products,
        seal_number,
        bill_of_lading,
        carrier_line,
        license_plate,
        container_number,
        tractor,
        packing_list,
        maneuvers,
        additional_services,
        cargo_type,
        commentary,
        description,
        status,
        patent_number,
        customs_number,
        customs_doc_type,
        notices,
        active,
        consignment_note,
        is_rfid,
        transport_type,
        is_national,
        modulation_status,
        emails,
        purchase_order,
        drivers_name,
        petition,
        entry_petition,
        remittance,
        merchandise_good_conditions,
        packaging_complies_conditions,
        seal_good_conditions,
        packing_type,
        unit_good_conditions,
        unit_damage_specifications,
        document_blobs,
        unknown_products,
        show_aduana,
        outcome_appointment,
        already_picked,
        files_status,
        deleted_at,
        warehouse,
        gate,
        order,
        appointment_status,
        client,
        operation,
        detail_orders,
        user,
        document_management
    }){
            this.id = id;
            this.eta = eta;
            this.arrival_date = arrival_date;
            this.modulation_date = modulation_date;
            this.modulation_time = modulation_time;
            this.origin_supplier = origin_supplier;
            this.standby_products = standby_products;
            this.seal_number = seal_number;
            this.bill_of_lading = bill_of_lading;
            this.carrier_line = carrier_line;
            this.license_plate = license_plate;
            this.container_number = container_number;
            this.tractor = tractor;
            this.packing_list = packing_list;
            this.maneuvers = maneuvers;
            this.additional_services = additional_services;
            this.cargo_type = cargo_type;
            this.commentary = commentary;
            this.description = description;
            this.status = status;
            this.patent_number = patent_number;
            this.customs_number = customs_number;
            this.customs_doc_type = customs_doc_type;
            this.notices = notices;
            this.active = active;
            this.consignment_note = consignment_note;
            this.is_rfid = is_rfid;
            this.transport_type = transport_type;
            this.is_national = is_national;
            this.modulation_status = modulation_status;
            this.emails = emails;
            this.purchase_order = purchase_order;
            this.drivers_name = drivers_name;
            this.petition = petition;
            this.entry_petition = entry_petition;
            this.remittance = remittance;
            this.merchandise_good_conditions = merchandise_good_conditions;
            this.packaging_complies_conditions = packaging_complies_conditions;
            this.seal_good_conditions = seal_good_conditions;
            this.packing_type = packing_type;
            this.unit_good_conditions = unit_good_conditions;
            this.unit_damage_specifications = unit_damage_specifications;
            this.document_blobs = document_blobs;
            this.unknown_products = unknown_products;
            this.show_aduana = show_aduana;
            this.outcome_appointment = outcome_appointment;
            this.already_picked = already_picked;
            this.files_status = files_status;
            this.deleted_at = deleted_at;
            this.warehouse = warehouse;
            this.gate = gate;
            this.order = order;
            this.appointment_status = appointment_status;
            this.client = client;
            this.operation = operation;
            this.detail_orders = detail_orders;
            this.user = user;
            this.document_management = document_management;
    }

    isValid() {
        return appointmentValidate(this);
    }
}